export default __webpack_public_path__ + "static/media/get_it_on_app_store_new.b2465131.png";